const rbacAuditLogConfig = {
  name: 'RBAC Audit Log',
  endpoint: '/internal_admin/admin_kit/rbac_audit_logs',

  columns: [
    { name: 'item_type', title: 'Resource', type: 'link' },
    { name: 'item_id', title: 'Record ID' },
    { name: 'event', title: 'Event' },
    { name: 'whodunnit_email', title: 'Changed By' },
    { name: 'created_at', title: 'When' },
  ],

  filters: [
    { name: 'q[item_type_cont]', label: 'Resource Type' },
    {
      name: 'q[event_eq]',
      label: 'Event',
      options: () => [
        { id: 'create', label: 'Create', value: 'create' },
        { id: 'update', label: 'Update', value: 'update' },
        { id: 'destroy', label: 'Destroy', value: 'destroy' },
      ],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'item_type', label: 'Resource Type' },
    { name: 'item_id', label: 'Record ID' },
    { name: 'event', label: 'Event' },
    { name: 'whodunnit_email', label: 'Changed By' },
    { name: 'changes_json', label: 'Changes', type: 'json' },
    { name: 'created_at', label: 'When' },
  ],
};

export default rbacAuditLogConfig;
